import React from 'react';
import CheckIcon from './CheckIcon';

export default function PricingCard({ plan, featured = false }) {
  const isPrimary = plan.variant === 'primary';

  if (isPrimary && featured) {
    return (
      <div className="bg-[#008180] w-full md:w-[300px] rounded-2xl border border-slate-100 shadow-lg overflow-hidden flex flex-col relative">
        <div className="px-6 py-10 pb-0 md:pb-8 md:text-center">
          <h3 className="font-inter font-semibold text-lg md:text-xl lg:text-3xl leading-[100%] tracking-[0%] text-white">
            {plan.name}
          </h3>
          <p className="text-base lg:text-[16px] font-inter font-medium md:leading-[34.61px] tracking-[0%] text-white">
            {plan.subtitle}
          </p>
        </div>
        <div className="bg-bg-tarif bg-cover bg-center bg-no-repeat p-4">
          <div className="md:text-end md:px-8 w-full font-inter text-white font-bold leading-[38px] tracking-[0%]">
            <span className="text-4xl lg:text-5xl">{plan.price}</span>
            {plan.currency && <span className="text-xs md:text-sm font-medium ml-1.5">{plan.currency}</span>}
          </div>
          {plan.period && (
            <p className="text-sm md:text-base md:text-center font-medium font-inter leading-38px mb-5 text-white tracking-[0%]">
              {plan.period}
            </p>
          )}
          <div className="px-6 w-full py-6 rounded-md flex-1 bg-white">
            <ul className="space-y-2.5">
              {plan.features.map((feature, idx) => (
                <li key={idx} className="flex items-center gap-3 text-sm text-[#1B1B1B]">
                  <div className="flex-shrink-0 w-5 h-5 rounded-full bg-[#008180] flex items-center justify-center">
                    <CheckIcon />
                  </div>
                  <span className="leading-[28px] font-inter font-medium tracking-[0%] text-[15px]">{feature}</span>
                </li>
              ))}
            </ul>
            <div className="px- mt-4">
              <button className="w-full bg-[#008180] text-white hover:bg-[#006666] font-semibold font-inter shadow-sm leading-[38px] tracking-[0%] py-2.5 rounded-full transition-colors text-md">
                {plan.buttonText}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white py-6 rounded-2xl w-full md:w-[300px] shadow-[0px_5px_11px_0px_#0000000D] overflow-hidden flex flex-col">
      <div className="p-6 md:text-center font-inter">
        <h3 className="text-lg md:text-2xl font-semibold leading-[100%] trancking-[0%] text-[#191A15] mb-1">
          {plan.name}
        </h3>
        <p className="text-sm md:text-base md:px-4 md:px-10 text-[#A6A6A6] font-medium leading-[34px] tracking-[0%] mb-5">
          {plan.subtitle}
        </p>
        <div className="mb-">
          <span className="text-4xl md:text-5xl font-bold text-[#191A15]">{plan.price}</span>
          {plan.currency && <span className="text-xs md:text-sm font-semibold text-[#000000] ml-1">{plan.currency}</span>}
        </div>
      </div>
      <div className="px-6 pb-4 flex-1">
        <ul className="space-y-2.5">
          {plan.features.map((feature, idx) => (
            <li key={idx} className="flex items-center gap-3 text-sm text-[#1B1B1B]">
              <div className="flex-shrink-0 w-5 h-5 rounded-full bg-[#008180] flex items-center justify-center">
                <CheckIcon />
              </div>
              <span className="leading-[28px] font-inter font-medium tracking-[0%] text-[15px]">{feature}</span>
            </li>
          ))}
        </ul>
      </div>
      <div className="px-6 pb-6">
        <button className="w-full bg-white text-[#008180] border border-[1.45px] border-slate-100  font-semibold font-inter shadow-sm leading-[38px] tracking-[0%] py-2 rounded-full transition-colors text-md">
          {plan.buttonText}
        </button>
      </div>
    </div>
  );
}
